module.exports = __webpack_public_path__ + "static/media/spoonerism-task (18).8189678b.mp3";